(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ruolo-funzione', {
            parent: 'entity',
            url: '/ruolo-funzione?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.ruoloFunzione.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ruolo-funzione/ruolo-funziones.html',
                    controller: 'RuoloFunzioneController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ruoloFunzione');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ruolo-funzione-detail', {
            parent: 'entity',
            url: '/ruolo-funzione/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.ruoloFunzione.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ruolo-funzione/ruolo-funzione-detail.html',
                    controller: 'RuoloFunzioneDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ruoloFunzione');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RuoloFunzione', function($stateParams, RuoloFunzione) {
                    return RuoloFunzione.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ruolo-funzione',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ruolo-funzione-detail.edit', {
            parent: 'ruolo-funzione-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ruolo-funzione/ruolo-funzione-dialog.html',
                    controller: 'RuoloFunzioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RuoloFunzione', function(RuoloFunzione) {
                            return RuoloFunzione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ruolo-funzione.new', {
            parent: 'ruolo-funzione',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ruolo-funzione/ruolo-funzione-dialog.html',
                    controller: 'RuoloFunzioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ruolo-funzione', null, { reload: 'ruolo-funzione' });
                }, function() {
                    $state.go('ruolo-funzione');
                });
            }]
        })
        .state('ruolo-funzione.edit', {
            parent: 'ruolo-funzione',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ruolo-funzione/ruolo-funzione-dialog.html',
                    controller: 'RuoloFunzioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RuoloFunzione', function(RuoloFunzione) {
                            return RuoloFunzione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ruolo-funzione', null, { reload: 'ruolo-funzione' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ruolo-funzione.delete', {
            parent: 'ruolo-funzione',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ruolo-funzione/ruolo-funzione-delete-dialog.html',
                    controller: 'RuoloFunzioneDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RuoloFunzione', function(RuoloFunzione) {
                            return RuoloFunzione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ruolo-funzione', null, { reload: 'ruolo-funzione' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
